import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { DataSourceParams, PageableDataSource, SelectOption } from '@fleet-beat/core';
import { untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { BehaviorSubject, Observable } from 'rxjs';
import { delay, filter } from 'rxjs/operators';
import { SimpleField } from '../../abstracts/simple-field';

@Component({
  selector: 'fb-data-radio',
  templateUrl: './data-radio.component.html',
  styleUrls: ['./data-radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataRadioComponent extends SimpleField<boolean | string | number | object> implements OnInit {
  @Input()
  set dataStorage(storage: PageableDataSource<Observable<SelectOption[]>, DataSourceParams<object, object>>) {
    this.localDataStorage = storage;
    this.reloadWithDelay.next();
  }
  get dataStorage(): PageableDataSource<Observable<SelectOption[]>, DataSourceParams<object, object>> {
    return this.localDataStorage;
  }
  @Input() options: SelectOption[];
  @Input() caption: string;

  private localDataStorage: PageableDataSource<Observable<SelectOption[]>, DataSourceParams<object, object>>;
  private reloadWithDelay: BehaviorSubject<void> = new BehaviorSubject(undefined);

  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    @Optional() @Self() public override ngControl: NgControl,
  ) {
    super(changeDetectorRef, ngControl);
  }

  ngOnInit(): void {
    this.setListeners();
  }

  private setListeners(): void {
    this.reloadWithDelay
      .pipe(
        delay(300),
        filter(() => Boolean(this.localDataStorage && this.localDataStorage.reloadSubject)),
        untilComponentDestroyed(this),
      )
      .subscribe(() => this.localDataStorage.reloadSubject.next({}));
  }
}
